import React, { useState, useEffect, useMemo } from 'react'
import { Grid, Container } from "@mui/material";
import { Link } from "react-router-dom";
import { Icon, Link as MUILink} from '@mui/material';
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import { Slide, Fade } from "react-awesome-reveal";

const ReadMore = ({data, slug, parseContent, homePage , section}) => {
	// const [entries, setEntries] = useState([]);
	const [sectionData] = useState(homePage[section].cards);
	const [currentIndex, setCurrentIndex] = useState(null);
	const entries = useMemo(() => data , [data]);
	useEffect(() => {
		if(entries.length === 1){
			setCurrentIndex(sectionData.indexOf(sectionData.find(i=>i.id === entries[0].id )))
		}
		return ()=>{
			setCurrentIndex(null)
		}
	} , [entries]);
	
	
  return (
		entries ? <Container sx={{p:{xs:0,md:"16px"}}} maxWidth="sm">
				{entries.map( (item, i ) => (
				<Fade direction='right' key={`article-${item.id}`} >
					<Link to={`/${slug}/${item.title}`}>
						<Grid container spacing={{md:2, xs : 1}} sx={{alignItems:"center", display:"flex", my:{sx:1,lg:2}}} >	
							<Grid item  xs={12} md={5} boxShadow="medium">
									<MDBox component="img" style={{width : "100%", height:"100%", objectFit:"cover"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/${section.toLowerCase()}/${item.img}`} alt={item.title} />
							</Grid>
							<Grid item  xs={12} md={7} sx={{alignSelf:"flex-start", mb:2}} boxShadow="medium">
								<Slide direction="right" cascade damping={0.3}>
									<MDTypography mt={2} mb={3} variant="h3">{item.title}</MDTypography>
									<MDBox style={{ color:"#2b2b2b",textAlign:"justify", "& p":{fontSize:{lg:1.1}, lineHeight : "1.1rem !important"} }}>{parseContent(item.text)}</MDBox>
								</Slide>
							</Grid>
						</Grid>
					</Link>
				</Fade>))}
				{entries.length === 1 && <MDBox maxWidth={{lg:"58%"}} ml="auto" display="flex" justifyContent="space-between" fontSize={15}>
					<MUILink sx={{ textAlign: 'center', cursor:"pointer", maxWidth:"45%", whiteSpace: "nowrap",textOverflow: "ellipsis", mr:"auto", overflow:"hidden"}}  component={Link} to={sectionData[currentIndex-1] ? `/${slug}/${sectionData[currentIndex-1].title}` : "/"} ><Icon sx={{mt:.5, mr:1}}>{sectionData[currentIndex-1] ? "arrow_left" : "home"} </Icon> {sectionData[currentIndex-1] ? sectionData[currentIndex-1].title : "Accueil"}</MUILink>
					{sectionData[currentIndex+1] && <MUILink sx={{ textAlign: 'center', cursor:"pointer", maxWidth:"45%", whiteSpace: "nowrap",textOverflow: "ellipsis", ml:"auto" , overflow:"hidden" }}  component={Link} to={sectionData[currentIndex+1] ? `/${slug}/${sectionData[currentIndex+1].title}` : "/"} ><Icon sx={{mt:.5, mr:1}}>arrow_right</Icon> {sectionData[currentIndex+1].title}</MUILink>}
				</MDBox>}
      </Container> : (<>empty</>)
  )
}

export default ReadMore